import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DataTable from 'base/components/table/DataTable/index';
import MainTitle from 'base/components/MainTitle/index';
import Header from 'base/components/Header/index';
import { AppsIcon, AddIcon } from 'base/components/Icon/index';
import { getAllTags } from 'documents/store/tags/selectors';
import { setActiveTagId, fetchAllTags } from 'documents/store/tags/actions';
import theme from 'theme/theme';
import Button from 'base/components/Button/index';
import ButtonGroup from 'base/components/ButtonGroup/index';
import { getDeleteColumn, getEditColumn } from 'base/components/table/RowActionButton';
import { openModal } from '../../../modal';


class ManageTags extends React.Component {
  componentDidMount() {
    const { fetchAll } = this.props;
    fetchAll();
  }

  handleEdit = (data) => {
    const { setActiveTagId, openModal } = this.props;
    setActiveTagId(data.id);
    openModal('TAG_EDIT');
  };

  handleDelete = (data) => {
    const { setActiveTagId, openModal } = this.props;
    setActiveTagId(data.id);
    openModal('TAG_DELETE');
  };

  render() {
    const { tags, openModal } = this.props;

    const columns = [
      {
        Header: 'Name',
        accessor: 'name',
        showOnMobile: true,
      },
      getEditColumn(this.handleEdit),
      getDeleteColumn(this.handleDelete),
    ];

    return (
      <>
        <Header>
          <MainTitle>
            <AppsIcon />
            {' '}
Manage Tags
          </MainTitle>
          <ButtonGroup pullRight>
            <Button onClick={() => openModal('TAG_CREATE')}>
              <AddIcon color={theme.colors.medium} />
              {' '}
New tag
            </Button>
          </ButtonGroup>
        </Header>
        <DataTable
          data={tags}
          columns={columns}
        />
      </>
    );
  }
}
ManageTags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchAll: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  setActiveTagId: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
  tags: getAllTags(state),
});

const mapDispatchToProps = {
  fetchAll: fetchAllTags,
  openModal,
  setActiveTagId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageTags);
